<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-account-search"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-row class="white mr-4 rounded-lg pa-4">
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="career.name"
                    filled
                    label="Vacancy"
                    placeholder="Enter vacancy"
                    @keyup="onKeyUp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="career.slug"
                    filled
                    label="Slug"
                    placeholder="Nhập slug"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="career.short_description"
                    filled
                    label="Short description"
                    placeholder="Enter short description"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <div class="my-4">Description</div>
                <ck-content :content="career.description" class="ck-content"
                            @getData="value => career.description = value"></ck-content>
              </v-col>
              <v-col cols="12">
                <v-select
                    chips
                    v-model="list_position_id"
                    :items="list_positions"
                    item-text="name"
                    item-value="id"
                    label="Kinh nghiệm"
                    multiple
                    outlined
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="career.upto_salary"
                    filled
                    label="Lương"
                    placeholder="Nhập lương"
                ></v-text-field>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="career.name_vi"
                    filled
                    label="Vị trí tuyển dụng"
                    placeholder="Nhập vị trí tuyển dụng"
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="margin-bottom: 86px"></v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="career.short_description_vi"
                    filled
                    label="Miêu tả ngắn"
                    placeholder="Nhập nhập miêu tả"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <div class="my-4">Mô tả</div>
                <ck-content :content="career.description_vi" class="ck-content"
                            @getData="value => career.description_vi = value"></ck-content>
              </v-col>
              <v-col cols="12">
                <v-select
                    chips
                    v-model="career.work_time"
                    :items="work_time"
                    item-text="name"
                    item-value="value"
                    outlined
                    label="Hình thức làm việc"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="career.address"
                    filled
                    label="Địa chỉ"
                    placeholder="Nhập địa chỉ "
                ></v-text-field>
              </v-col>
            </v-col>
            <v-col class="d-flex justify-center" cols="12">
              <v-btn class="px-10" color="primary" elevation="6" width="180" @click="save">LƯU</v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>


    </v-container>
  </v-col>
</template>

<script>
import CkContent from "@/components/ck-content"
import {mapGetters} from "vuex";
import {GET_LIST_POSITION} from "@/store/modules/position";
import {SAVE_CAREER} from "@/store/modules/career";
import validateSlug from "@/mixins/validateSlug";

export default {
  name: "Add_carrer",
  mixins: [validateSlug],
  components: {
    CkContent,
  },
  data() {
    return {
      page: "Thêm career",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Carrers",
          disabled: true,
        },
        {
          text: "Thêm career",
          disabled: false,
        },
      ],
      work_time: [
        {
          name: 'Fulltime',
          value: 1
        },
        {
          name: 'Partime',
          value: 2
        }
      ],
      list_positions: [],
      list_position_id: [],
      career: {
        name: '',
        name_vi: '',
        description: '',
        description_vi: '',
        upto_salary: '',
        work_time: 0,
        position_tags: [],
        address: '',
        slug: '',
        short_description: '',
        short_description_vi: '',
      }
    }
  },
  computed: {
    ...mapGetters({
      position: "position",
    }),

  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_POSITION}`);
  },
  watch: {
    position(val) {
      if (val) {
        const _this = this
        val.forEach(el => {
          _this.list_positions.push({
            id: el.id,
            name: el.name,
          })
        })
      }
    },
  },
  methods: {
    onKeyUp(value) {
      this.career.slug = this.sanitizeTitle(value.target.value)
    },
    async save() {
      const _this = this;
      //list tags
      this.list_position_id.forEach(id => {
        let tag = _this.list_positions.find(el => el.id == id)
        _this.career.position_tags.push(tag.id
        )
      })
      let data = {
        name: this.career.name,
        name_vi: this.career.name_vi,
        description_vi: this.career.description_vi,
        description: this.career.description,
        upto_salary: this.career.upto_salary,
        work_time: this.career.work_time,
        position_tags: this.career.position_tags,
        address: this.career.address,
        slug: this.career.slug,
        short_description: this.career.short_description,
        short_description_vi: this.career.short_description_vi,
      }
      await this.$store.dispatch(`${SAVE_CAREER}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/career_management/career')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }

}
</script>

<style scoped>
.ck-project .ck-editor__main .ck-content {
  height: 140px;
}
</style>